// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";
import translate from "@insite/client-framework/Translate";
import { TellAFriendModel } from "@insite/client-framework/Types/ApiModels";

const emailSubscriptionUrl = "/api/custom/mailChimp/SubscribeToList";

export interface TellAFriendApiParameter extends ApiParameter {
    tellAFriendModel: TellAFriendModel;
}

export interface SubscribeToListApiParameter extends ApiParameter {
    emailAddress: string;
}

export function subscribeToList(parameter: SubscribeToListApiParameter) {
    return post<SubscribeToListApiParameter>(`${emailSubscriptionUrl}`, parameter).then(
        (response: any) => {
            /**
             * Do some staff here
             */
        },
        (error: any) => {
            throw new Error(translate("An error occurred, please try again later."));
        },
    );
}
